"use strict";

import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
export var icon = _7a468({
  defaultClassName: "Link_icon__1hf0aro7",
  variantClassNames: {
    position: {
      start: "Link_icon_position_start__1hf0aro8",
      end: "Link_icon_position_end__1hf0aro9"
    },
    animation: {
      "slide-start": "Link_icon_animation_slide-start__1hf0aroa",
      "slide-end": "Link_icon_animation_slide-end__1hf0arob"
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
export var link = "Link_link__1hf0aro3 Controls_controlFocusRing__a2bdyy2 Buttons_buttonReset__yodxo10";
export var text = "Link_text__1hf0aro4";